// extracted by mini-css-extract-plugin
export default {"noCardsHead":"EmptyContentPage_noCardsHead__2SZxX","noCards":"EmptyContentPage_noCards__02i+f"};